import React from 'react';
import {Button} from "reactstrap";
import {EditElementModal} from "../../EditElementModal";
import {
    SelectAdgroupsMultiSelectModalForm,
    SelectCampaignsMultiSelectModalForm
} from "./SelectItemsMultiSelectModalForm";
import { withTranslation } from 'react-i18next';


export class SelectItemsMultiSelectModal extends EditElementModal {
    renderModalForm() {
        throw Error("Must override method")
    }

    renderButton() {
        throw Error("Must override method")
    }

    renderModalHeaderText() {
        throw Error("Must override method")
    }
}

class SelectCampaignsMultiSelectModalComponent extends SelectItemsMultiSelectModal {
    renderModalForm() {
        return <SelectCampaignsMultiSelectModalForm closeModal={this.toggle}
                                                    onModified={this.handleFormSubmitted}
                                                    campaigns={this.props.campaigns}
                                                    isUpdatingListItems={this.props.isUpdatingListItems}
                                                    messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                                                    onRefreshListItems={this.props.onRefreshListItems}
                                                    onLoadInactiveItems={this.props.onLoadInactiveItems}
                                                    isLoadingInactiveItems={this.props.isLoadingInactiveItems}
                                                    inactiveItemsAreLoaded={this.props.inactiveItemsAreLoaded}
        />
    }

    renderButton() {
        const buttonText = this.props.buttonText !== undefined ? this.props.buttonText : "+ Agregar campañas";
        return <Button key="button" className="btn -alt me-2" onClick={this.toggle}>{buttonText}</Button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        return t('select_items.select_campaigns');
    }
}

class SelectAdgroupsMultiSelectModalComponent extends SelectItemsMultiSelectModal {
    renderModalForm() {
        return <SelectAdgroupsMultiSelectModalForm closeModal={this.toggle}
                                                   onModified={this.handleFormSubmitted}
                                                   adgroups={this.props.adgroups}
                                                   onRefreshItemsList={this.props.onRefreshItemsList}
                                                   isUpdatingListItems={this.props.isUpdatingListItems}
                                                   messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                                                   onRefreshListItems={this.props.onRefreshListItems}
                                                   onLoadInactiveItems={this.props.onLoadInactiveItems}
                                                   isLoadingInactiveItems={this.props.isLoadingInactiveItems}
                                                   inactiveItemsAreLoaded={this.props.inactiveItemsAreLoaded}
        />
    }

    renderButton() {
        const { t } = this.props;
        const buttonText = this.props.buttonText !== undefined ? this.props.buttonText : t('select_items.add_adgroups_button');
        return <Button key="button" className="btn -alt me-2" onClick={this.toggle}>{buttonText}</Button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        return t('select_items.select_adgroups');
    }
}

export const SelectCampaignsMultiSelectModal = withTranslation()(SelectCampaignsMultiSelectModalComponent);
export const SelectAdgroupsMultiSelectModal = withTranslation()(SelectAdgroupsMultiSelectModalComponent);